function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/917733982109?text=Hello%20I%20am%20interested%20in%20your%20products"
      className="whatsapp"
      target="_blank"
      rel="noopener noreferrer"
    >
      💬
    </a>
  );
}

export default WhatsAppButton;